/* tslint:disable:max-classes-per-file */
/** Define uma seção de recursos (URI) */
class RoutesTableSection {
    constructor(
        public readonly routes: { [key: string]: RoutesTableSectionItem }
    ) {}
}
export class RoutesTableSectionItem {
    /**
     * URI do recurso
     */
    public uri: string;
    constructor(value: string) {
        this.uri = value;
    }
}

// Temporary constant for the new product's APIs migartion

export class RoutesTable {
    public static hubProjectsURLS: RoutesTableSection = new RoutesTableSection({
        LoggedHome: new RoutesTableSectionItem("/home/patrimonio"),
    });

    public static cadastroPFURLS: RoutesTableSection = new RoutesTableSection({
        RegisterPersonalInformation: new RoutesTableSectionItem(
            "/cadastro/dados-pessoais"
        ),
        RegisterDocsOfAge: new RoutesTableSectionItem(
            "/cadastro/documentacao-maior"
        ),
        RegisterDocsMinor: new RoutesTableSectionItem(
            "/cadastro/documentacao-menor"
        ),
        RegisterBankEntry: new RoutesTableSectionItem("/cadastro/banco"),
        AddressRegister: new RoutesTableSectionItem("/cadastro/endereco"),
        RegisterPatrimony: new RoutesTableSectionItem("/cadastro/patrimonio"),
        RegisterIntent: new RoutesTableSectionItem("/cadastro/objetivos"),
        RegisterEnd: new RoutesTableSectionItem(
            "/cadastro/cadastro-finalizado"
        ),
        SendDocsPF: new RoutesTableSectionItem("/cadastro/enviar-docs"),
        DocsPFSuccess: new RoutesTableSectionItem("/cadastro/docs-enviados"),
    });

    public static cadastroPJURLS: RoutesTableSection = new RoutesTableSection({
        companyData: new RoutesTableSectionItem("/cadastro-pj/dados-companhia"),
        companyAddress: new RoutesTableSectionItem("/cadastro-pj/endereco"),
        CompanyPartners: new RoutesTableSectionItem("/cadastro-pj/socios"),
        CompanyBank: new RoutesTableSectionItem("/cadastro-pj/banco"),
        CompanyPatrimony: new RoutesTableSectionItem("/cadastro-pj/patrimonio"),
        CompanyEnterprises: new RoutesTableSectionItem("/cadastro-pj/empresas"),
        CompanyEmitter: new RoutesTableSectionItem("/cadastro-pj/emissores"),
        CompanyFinal: new RoutesTableSectionItem(
            "/cadastro-pj/cadastro-finalizado"
        ),
        SendDocsCNPJ: new RoutesTableSectionItem("/cadastro-pj/enviar-docs"),
        FinalSuccess: new RoutesTableSectionItem("/cadastro-pj/docs-enviados"),
    });

    /** Rotas do userprofile */
    public static hubUrls: RoutesTableSection = new RoutesTableSection({
        /* CADASTRO */
        // cadastro
        cadastro: new RoutesTableSectionItem("/cadastro"),

        Login: new RoutesTableSectionItem("/entrar"),

        // nossa empresa
        OutCompany: new RoutesTableSectionItem("/nossa-empresa"),
        OutCompanyRegulamentation: new RoutesTableSectionItem(
            "/regulamentacao"
        ),

        // venda guiada
        GuidedSale: new RoutesTableSectionItem("/plano-personalizado"),
        GuidedSaleIntro: new RoutesTableSectionItem(
            "/plano-personalizado/introducao"
        ),
        GuidedSaleValueInvest: new RoutesTableSectionItem(
            "/plano-personalizado/valor"
        ),
        GuidedSaleMonthInvest: new RoutesTableSectionItem(
            "/plano-personalizado/investimento-mensal"
        ),
        GuidedSaleGoal: new RoutesTableSectionItem(
            "/plano-personalizado/objetivo"
        ),
        GuidedSaleLiquity: new RoutesTableSectionItem(
            "/plano-personalizado/resgate"
        ),
        GuidedSalePeriod: new RoutesTableSectionItem(
            "/plano-personalizado/investimento"
        ),
        GuidedSaleRisk: new RoutesTableSectionItem(
            "/plano-personalizado/risco"
        ),
        GuidedSaleResults: new RoutesTableSectionItem(
            "/plano-personalizado/resultado"
        ),

        // produto
        Product: new RoutesTableSectionItem("/produto"),
        ProductCdb: new RoutesTableSectionItem("/produto/cdb"), // recebe parametros
        ProductTesouroDireto: new RoutesTableSectionItem(
            "/produto/tesouro-direto"
        ), // recebe parametros
        ProductWallet: new RoutesTableSectionItem("/produto/carteira"),

        // Landings
        LandingsTransfer: new RoutesTableSectionItem("/info/transferencia"),
        LandingsCustos: new RoutesTableSectionItem("/info/custos"),
        LandingsPress: new RoutesTableSectionItem("/info/imprensa"),
        LandingsWorkWithUs: new RoutesTableSectionItem(
            "/info/trabalhe-com-a-gente"
        ),

        // Aprenda
        learnHome: new RoutesTableSectionItem("/aprenda"),
        knowToroCourse: new RoutesTableSectionItem(
            "/aprenda/cursos/conheca-a-toro"
        ),
        introductionCourse: new RoutesTableSectionItem(
            "/aprenda/cursos/introducao"
        ),
        fixedIncomeCourse: new RoutesTableSectionItem(
            "/aprenda/cursos/renda-fixa-e-tesouro"
        ),
        stocksExchangeCourse: new RoutesTableSectionItem(
            "/aprenda/cursos/bolsa-de-valores"
        ),
        planningCourse: new RoutesTableSectionItem(
            "/aprenda/cursos/crie-o-seu-futuro"
        ),

        // Checkout
        Checkout: new RoutesTableSectionItem("/carrinho"),
        CheckoutTerms: new RoutesTableSectionItem("/carrinho/termos"),

        // Notas
        NoteBMF: new RoutesTableSectionItem("/nota/bmf"),
        NoteBovespaAcoes: new RoutesTableSectionItem("/nota/acoes"),
        NoteBovespa: new RoutesTableSectionItem("/nota/bovespa"),
        NoteFinancial: new RoutesTableSectionItem("/nota/financeiro"),
        NoteFixed: new RoutesTableSectionItem("/nota/fixa"),

        // Saque
        Draft: new RoutesTableSectionItem("/saque"),
        DraftError: new RoutesTableSectionItem("/saque/erro"),

        // Resgate
        Rescue: new RoutesTableSectionItem("/resgate"),
        RescueSuccess: new RoutesTableSectionItem("/resgate/sucesso"),
        RescueFailed: new RoutesTableSectionItem("/resgate/error"),

        // Bolsa
        StockHome: new RoutesTableSectionItem("/bolsa"),
        StockHomeComparative: new RoutesTableSectionItem("/bolsa/investir"),
        StockHomeInvestments: new RoutesTableSectionItem(
            "/bolsa/meus-investimentos"
        ),
        StockAnalysisComponent: new RoutesTableSectionItem("/bolsa/analise"),
        StockPlannedCheckout: new RoutesTableSectionItem(
            "/bolsa/checkout/planejado"
        ),
        StockUnplannedCheckout: new RoutesTableSectionItem("/bolsa/checkout"),
        StockTracking: new RoutesTableSectionItem("/bolsa/acompanhamento"),

        // Logged Area
        LoggedHome: new RoutesTableSectionItem("/logged/home"),
        LoggedChangePass: new RoutesTableSectionItem("/logged/trocadesenha"),

        // Suitability
        Suitability: new RoutesTableSectionItem("/perfil"),
        SuitabilityLiquity: new RoutesTableSectionItem("/perfil/1"),
        SuitabilityRisk: new RoutesTableSectionItem("/perfil/2"),
        SuitabilityGoal: new RoutesTableSectionItem("/perfil/3"),
        SuitabilityIncome: new RoutesTableSectionItem("/perfil/4"),
        SuitabilityInvestments: new RoutesTableSectionItem("/perfil/5"),
        SuitabilityPeriod: new RoutesTableSectionItem("/perfil/6"),
        SuitabilityKnowledge: new RoutesTableSectionItem("/perfil/7"),
        SuitabilityHistory: new RoutesTableSectionItem("/perfil/8"),
        SuitabilityEducation: new RoutesTableSectionItem("/perfil/9"),
        SuitabilityResult: new RoutesTableSectionItem("/perfil/10"),
        SuitabilityResult_1: new RoutesTableSectionItem("/perfil/resultado"),

        // Minha conta
        MyAccount: new RoutesTableSectionItem("/minha-conta"),
        MyAccountPassword: new RoutesTableSectionItem("/minha-conta/senha"),
        MyAccountPasswordChange: new RoutesTableSectionItem(
            "/minha-conta/senha/alterar"
        ),

        MyAccountEmailAndPhone: new RoutesTableSectionItem(
            "/minha-conta/email-e-celular"
        ),
        MyAccountEmailAndPhoneChange: new RoutesTableSectionItem(
            "/minha-conta/email-e-celular/edit"
        ),
        MyAccountEmailAndPhoneSuccess: new RoutesTableSectionItem(
            "/minha-conta/email-e-celular/success"
        ),

        MyAccountGuaranty: new RoutesTableSectionItem("/minha-conta/garantia"),
        MyAccountPerfil: new RoutesTableSectionItem(
            "/minha-conta/perfil-do-investidor"
        ),
        MyAccountContracts: new RoutesTableSectionItem(
            "/minha-conta/contratos"
        ),
        MyAccountTaxes: new RoutesTableSectionItem("/minha-conta/imposto"),

        MyAccountPersonalData: new RoutesTableSectionItem(
            "/minha-conta/dados-pessoais"
        ),
        MyAccountPersonalDataEdit: new RoutesTableSectionItem(
            "/minha-conta/dados-pessoais/edit"
        ),
        MyAccountPersonalDataEditName: new RoutesTableSectionItem(
            "/minha-conta/dados-pessoais/edit-name"
        ),

        MyAccountBankData: new RoutesTableSectionItem(
            "/minha-conta/dados-bancarios"
        ),
        MyAccountBankDataEdit: new RoutesTableSectionItem(
            "/minha-conta/dados-bancarios/edit"
        ),

        MyAccountPacotesCorretagem: new RoutesTableSectionItem(
            "/minha-conta/pacotes-corretagem"
        ),

        MyAccountPacotesCorretagemPackageEdit: new RoutesTableSectionItem(
            "/minha-conta/pacotes-corretagem/pacotes"
        ),
        MyAccountPacotesCorretagemPackageAdd: new RoutesTableSectionItem(
            "/minha-conta/pacotes-corretagem/pacotes/add"
        ),
        MyAccountPacotesCorretagemPackageTerms: new RoutesTableSectionItem(
            "/minha-conta/pacotes-corretagem/pacotes/termos"
        ),

        MyAccountHomeAddress: new RoutesTableSectionItem(
            "/minha-conta/endereco-residencial"
        ),
        MyAccountHomeAddressEdit: new RoutesTableSectionItem(
            "/minha-conta/endereco-residencial/edit"
        ),

        MyAccountIncomeAndEquity: new RoutesTableSectionItem(
            "/minha-conta/renda-e-patrimonio"
        ),
        MyAccountIncomeAndEquityEdit: new RoutesTableSectionItem(
            "/minha-conta/renda-e-patrimonio/edit"
        ),

        MyAccountBusinessData: new RoutesTableSectionItem(
            "/minha-conta/dados-empresa"
        ),
        MyAccountBusinessDataEdit: new RoutesTableSectionItem(
            "/minha-conta/dados-empresa/edit"
        ),

        MyAccountSocietalStructure: new RoutesTableSectionItem(
            "/minha-conta/estrutura-societaria"
        ),
        MyAccountSocietalStructureEdit: new RoutesTableSectionItem(
            "/minha-conta/estrutura-societaria/edit"
        ),

        MyAccountBusinessAddress: new RoutesTableSectionItem(
            "/minha-conta/endereco-empresarial"
        ),
        MyAccountBusinessAddressEdit: new RoutesTableSectionItem(
            "/minha-conta/endereco-empresarial/edit"
        ),

        MyAccountBusinessIncomeAndEquity: new RoutesTableSectionItem(
            "/minha-conta/renda-e-patrimonio-empresarial"
        ),
        MyAccountBusinessIncomeAndEquityEdit: new RoutesTableSectionItem(
            "/minha-conta/renda-e-patrimonio-empresarial/edit"
        ),

        MyAccountLimits: new RoutesTableSectionItem(
            "/minha-conta/limites-para-investir"
        ),
        MyAccountLimitsEdit: new RoutesTableSectionItem(
            "/minha-conta/limites-para-investir/edit"
        ),

        // renda fixa
        FixedIncome: new RoutesTableSectionItem("/renda-fixa"),
        FixedIncomeComparative: new RoutesTableSectionItem(
            "/renda-fixa/investir"
        ),
        FixedIncomeInvestments: new RoutesTableSectionItem(
            "/renda-fixa/meus-investimentos"
        ),

        // URL DE API ABAIXO!
        getLogoFile: new RoutesTableSectionItem("fixedincome/issuer/logo/{0}"),

        // atendimento
        attendance: new RoutesTableSectionItem("/atendimento"),
        attendanceOptions: new RoutesTableSectionItem("/atendimento/assessor"),
        attendanceAssessor: new RoutesTableSectionItem(
            "/atendimento/chat-online"
        ),
        attendanceChat: new RoutesTableSectionItem("/chat"),
        // as rotas do faq recebem parametros na primera e na segunda barra
        faq: new RoutesTableSectionItem("/faq"),

        // pages
        ForgotPasswordForm: new RoutesTableSectionItem("/esqueci-minha-senha"),
        ChangePass: new RoutesTableSectionItem("/recuperar-senha"),
        Links: new RoutesTableSectionItem("/links"),
        Uploads: new RoutesTableSectionItem("/uploads"),
        Home: new RoutesTableSectionItem("/inicio"),
        Testes: new RoutesTableSectionItem("/testes"),
        AboutToro: new RoutesTableSectionItem("/somos-a-toro"),
        StyleGuide: new RoutesTableSectionItem("/styleGuide"),
    });

    /** Rotas do userprofile */
    public static userprofile: RoutesTableSection = new RoutesTableSection({
        get: new RoutesTableSectionItem("userprofile"),
        update: new RoutesTableSectionItem("userprofile"),
        basicRegistration: new RoutesTableSectionItem(
            "userprofile/basicregistration"
        ),
        uploadDocument: new RoutesTableSectionItem(
            "v1.1/users/documentation/upload/{0}"
        ),
        updatePhone: new RoutesTableSectionItem(
            "userprofile/changephonenumber"
        ),
        notifyConclusion: new RoutesTableSectionItem(
            "userprofile/notifyconclusion/{0}"
        ),
        notifyConclusionToroUser: new RoutesTableSectionItem(
            "v1.1/users/notifyconclusion/{0}"
        ),
        getCblcArray: new RoutesTableSectionItem("/userprofile/accountcblc"),
    });

    /** Rotas de company */
    public static usercompany: RoutesTableSection = new RoutesTableSection({
        get: new RoutesTableSectionItem("userprofile/corporatecustomer"),
    });

    /** Rotas de communication */
    public static communication: RoutesTableSection = new RoutesTableSection({
        sendTransferAccountInformations: new RoutesTableSectionItem(
            "communication/sendtransferaccountinformations"
        ),
    });

    /** Rotas Agreemente */
    public static agreement: RoutesTableSection = new RoutesTableSection({
        getAcceptedAgreements: new RoutesTableSectionItem("agreement/accept"),
        acceptAgreement: new RoutesTableSectionItem("agreement/accept"),
        getAgreement: new RoutesTableSectionItem("agreement/{0}"),
    });

    /** Rotas Agreement */
    public static agreementV1_1: RoutesTableSection = new RoutesTableSection({
        getAcceptedAgreements: new RoutesTableSectionItem(
            "/agreement/v1.1/agreement/accept"
        ),
        acceptAgreement: new RoutesTableSectionItem(
            "/agreement/v1.1/agreement/accept"
        ),
        getAgreement: new RoutesTableSectionItem("/agreement/v1.1/agreement/"),
    });

    public static authentication: RoutesTableSection = new RoutesTableSection({
        requestForgotPasswordEmail: new RoutesTableSectionItem(
            "auth/authentication/forgotpassword/requestemail"
        ),
        validateTokenForgotPasswordEmail: new RoutesTableSectionItem(
            "auth/authentication/validatetoken"
        ),
        authenticateUserUsingComplexToken: new RoutesTableSectionItem(
            "auth/authentication/login"
        ),
        recoverPassword: new RoutesTableSectionItem(
            "auth/authentication/forgotpassword"
        ),
        login: new RoutesTableSectionItem("auth/authentication/login"),
        requestTokenTime: new RoutesTableSectionItem(
            "auth/authentication/token/request"
        ),
        updatePassword: new RoutesTableSectionItem(
            "auth/authentication/changepassword"
        ),
        logout: new RoutesTableSectionItem("auth/authentication/logout"),
        requestUnlockAccountEmail: new RoutesTableSectionItem(
            "auth/authentication/unlock/request?username={0}"
        ),
        unlockAccount: new RoutesTableSectionItem("auth/authentication/unlock"),
        getLasModifiedPasswordDate: new RoutesTableSectionItem(
            "auth/authentication/lastmodifiedpassword"
        ),
        getHasDevice: new RoutesTableSectionItem(
            "auth/authentication/hasdevice"
        ),
        getSessionID: new RoutesTableSectionItem(
            "auth/authentication/session/{0}"
        ),
        changeTelephone: new RoutesTableSectionItem(
            "auth/authentication/changetelephone/requestemail"
        ),
        getUserBasicData: new RoutesTableSectionItem(
            "auth/authentication/user"
        ),
        requestTokenMonthly: new RoutesTableSectionItem(
            "auth/authentication/token/request/monthly"
        ),
    });

    public static suitability: RoutesTableSection = new RoutesTableSection({
        getUserSuitability: new RoutesTableSectionItem(
            "suitability/user/suitability"
        ),
        updateUserAnswers: new RoutesTableSectionItem(
            "suitability/user/answer"
        ),
        getUserAnswers: new RoutesTableSectionItem("suitability/user/answer"),
        getQuestions: new RoutesTableSectionItem("suitability/question"),
        getQuestion: new RoutesTableSectionItem("suitability/question/{0}"),
        getAnswers: new RoutesTableSectionItem("suitability/answer"),
        setGuidedsale: new RoutesTableSectionItem("suitability/customplan"),
    });

    public static corporation: RoutesTableSection = new RoutesTableSection({
        getCities: new RoutesTableSectionItem(
            "corporation/city?$inlinecount=allpages"
        ),
        getCity: new RoutesTableSectionItem("corporation/city/{0}"),
        getActivities: new RoutesTableSectionItem(
            "corporation/activity?$orderby=Index&$inlinecount=allpages"
        ),
        getEducation: new RoutesTableSectionItem(
            "corporation/educationdegree?$inlinecount=allpages"
        ),
        getMarital: new RoutesTableSectionItem(
            "corporation/maritalStatus?$inlinecount=allpages"
        ),
        getCountries: new RoutesTableSectionItem(
            "corporation/country?$inlinecount=allpages"
        ),
        getEmitters: new RoutesTableSectionItem(
            "corporation/documentemitter?$inlinecount=allpages"
        ),
        getDocumentType: new RoutesTableSectionItem(
            "corporation/documenttype?$inlinecount=allpages"
        ),
        getEconomicActivities: new RoutesTableSectionItem(
            "corporation/economicactivity?$inlinecount=allpages"
        ),
        getStates: new RoutesTableSectionItem(
            "corporation/state?$inlinecount=allpages"
        ),
        getAccountType: new RoutesTableSectionItem("corporation/accountType"),
        getBanks: new RoutesTableSectionItem("corporation/bank"),
        getWorkingDays: new RoutesTableSectionItem(
            "corporation/workingdays?startDate={0}&endDate={1}"
        ),
        getWorkingDaysBovespa: new RoutesTableSectionItem(
            "corporation/workingdaysbovespa?startDate={0}&endDate={1}"
        ),
        getBlobFile: new RoutesTableSectionItem(
            "corporation/file?fileCode={0}"
        ),
    });

    public static corporationV1_1: RoutesTableSection = new RoutesTableSection({
        getCities: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/city?$inlinecount=allpages"
        ),
        getCity: new RoutesTableSectionItem("corporation/city/{0}"),
        getActivities: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/activity?$orderby=Index&$inlinecount=allpages"
        ),
        getEducation: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/educationdegree?$inlinecount=allpages"
        ),
        getMarital: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/maritalStatus?$inlinecount=allpages"
        ),
        getCountries: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/country?$inlinecount=allpages"
        ),
        getEmitters: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/documentemitter?$inlinecount=allpages"
        ),
        getDocumentType: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/documenttype?$inlinecount=allpages"
        ),
        getEconomicActivities: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/economicactivity?$inlinecount=allpages"
        ),
        getStates: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/state?$inlinecount=allpages"
        ),
        getNationalities: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/nationality"
        ),
        getAccountType: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/accountType"
        ),
        getBanks: new RoutesTableSectionItem("/corp/v1.1/corporation/bank"),
        getWorkingDays: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/workingdays?startDate={0}&endDate={1}"
        ),
        getWorkingDaysBovespa: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/workingdaysbovespa?startDate={0}&endDate={1}"
        ),
        getBlobFile: new RoutesTableSectionItem(
            "/corp/v1.1/corporation/file?fileCode={0}"
        ),
    });

    public static exchange: RoutesTableSection = new RoutesTableSection({
        getClientOrders: new RoutesTableSectionItem(
            "exchange/order/client?$orderby=CreationDate,TransactionTime"
        ),
        getClientValidOrders: new RoutesTableSectionItem(
            "exchange/order/client/valid?$orderby=CreationDate,TransactionTime"
        ),
        getClientOrder: new RoutesTableSectionItem(
            "exchange/order?orderID={0}"
        ),
        getClientStrategies: new RoutesTableSectionItem(
            "exchange/strategy/client"
        ),
        getClientValidStrategies: new RoutesTableSectionItem(
            "exchange/strategy/client/valid"
        ),
        getClientStrategy: new RoutesTableSectionItem(
            "exchange/strategy?strategyID={0}"
        ),
        newOrder: new RoutesTableSectionItem("exchange/order/new"),
        editOrder: new RoutesTableSectionItem("exchange/order/edit"),
        newStrategy: new RoutesTableSectionItem("exchange/strategy/new"),
        editStrategy: new RoutesTableSectionItem("exchange/strategy/edit"),
        shutDownStrategy: new RoutesTableSectionItem(
            "exchange/strategy/shutdown"
        ),
        closeStrategy: new RoutesTableSectionItem("exchange/strategy/close"),
        closeOrder: new RoutesTableSectionItem("exchange/order/close"),
        tradingDates: new RoutesTableSectionItem("exchange/tradingdates"),
        getOrdersSearch: new RoutesTableSectionItem(
            "exchange/order/client?$filter={0}&$orderby=CreationDate,TransactionTime"
        ),
        getStrategiesSearch: new RoutesTableSectionItem(
            "exchange/strategy/client?$filter={0}"
        ),
        cancelStrategy: new RoutesTableSectionItem("exchange/strategy/cancel"),
        cancelOrder: new RoutesTableSectionItem("exchange/order/cancel"),
        getInvestments: new RoutesTableSectionItem("exchange/myinvestments"),
        getTradingTime: new RoutesTableSectionItem("exchange/tradinghour"),
        getMyHistoricStrategies: new RoutesTableSectionItem(
            "exchange/strategy/client/executiondate?$filter={0}"
        ),
    });

    public static research: RoutesTableSection = new RoutesTableSection({
        getMostTraded: new RoutesTableSectionItem(
            "research/mosttraded?$top=12"
        ),
        getPriceBands: new RoutesTableSectionItem(
            "research/pricebands?symbol={0}&operationType={1}"
        ),
        getOpportunities: new RoutesTableSectionItem("research/oportunities"),
        getOpportunity: new RoutesTableSectionItem("research/oportunities/{0}"),
        getCategories: new RoutesTableSectionItem(
            "research/categorizedoportunities"
        ),
    });

    public static quote: RoutesTableSection = new RoutesTableSection({
        searchStocks: new RoutesTableSectionItem(
            "quote/instrument?$orderby=Rank&$filter={0}&$top={1}"
        ),
        newSearch: new RoutesTableSectionItem(
            "quote/instruments/{0}?$orderby=ResultPriority, Code&top=4"
        ),
        lastHourHistory: new RoutesTableSectionItem(
            "quotehistory/byMinute/{0}/60?$orderby=QuoteDate desc&$select=QuoteDate, ValueLastTrade"
        ),
        lastDayHistory: new RoutesTableSectionItem(
            "quotehistory/byFifteenMinutes/{0}/36?$orderby=QuoteDate desc&$select=QuoteDate, ValueLastTrade"
        ),
        lastWeekHistory: new RoutesTableSectionItem(
            "quotehistory/daily/{0}/7?$orderby=QuoteDate desc&$select=QuoteDate, ValueLastTrade"
        ),
        lastMonthHistory: new RoutesTableSectionItem(
            "quotehistory/daily/{0}/21?$orderby=QuoteDate desc&$select=QuoteDate, ValueLastTrade"
        ),
        lastYearHistory: new RoutesTableSectionItem(
            "quotehistory/daily/{0}/252?$orderby=QuoteDate desc&$select=QuoteDate, ValueLastTrade"
        ),
        lastFiveYearsHistory: new RoutesTableSectionItem(
            "quotehistory/daily/{0}/1260?$orderby=QuoteDate desc&$select=QuoteDate, ValueLastTrade"
        ),
        getInstrumentInfo: new RoutesTableSectionItem("quote/instrument/{0}"
        ),
        getInstrumentsInfoByArray: new RoutesTableSectionItem(
            "quote/instrument?$filter={0}"
        ),
        getTrends: new RoutesTableSectionItem("quote/trend/{0}/12"
        ),
        getQuoteInfo: new RoutesTableSectionItem("quote/quote/{0}"
        ),
    });

    /** Media */
    public static media: RoutesTableSection = new RoutesTableSection({
        getVideosByGroupId: new RoutesTableSectionItem("media/mediagroup/{0}"),
        updateSeenProgress: new RoutesTableSectionItem("media/userhistory"),
    });

    /** Environment */
    public static environment: RoutesTableSection = new RoutesTableSection({
        getEnvironments: new RoutesTableSectionItem("environment/{0}"),
        getEnvironmentConfig: new RoutesTableSectionItem("environment.json"),
        getEnvironmentMachine: new RoutesTableSectionItem(
            "environment/machine"
        ),
    });

    /** Billing */
    public static billing: RoutesTableSection = new RoutesTableSection({
        getBrokerageTax: new RoutesTableSectionItem(
            "billing/brokeragetaxforecast?param.isDayTrade={0}&param.orderQty={1}&param.plataform={2}&param.price={3}&param.symbol={4}"
        ),
        getBrokerageModel: new RoutesTableSectionItem(
            "billing/brokerage/user/model"
        ),
        setBrokerageModel: new RoutesTableSectionItem(
            "billing/brokerage/user/model?brokerageUserModelType={0}"
        ),
        getLastMonthlyScore: new RoutesTableSectionItem(
            "billing/business/lastmonthlyscore"
        ),
    });

    /** Pós risco */
    public static posRisk: RoutesTableSection = new RoutesTableSection({
        getRiskModel: new RoutesTableSectionItem("posrisk/riskmodel"),
        updateRiskModel: new RoutesTableSectionItem("posrisk/riskmodel"),
        getOneStress: new RoutesTableSectionItem("posrisk/stress/{0}/{1}/{2}"),
        getCustodyClient: new RoutesTableSectionItem("posrisk/custodyclient"),
        getConsolidatePosition: new RoutesTableSectionItem(
            "posrisk/consolidatedposition"
        ),
        getAllStress: new RoutesTableSectionItem("posrisk/stress"),
        getIbovespaStressWithFilter: new RoutesTableSectionItem(
            "posrisk/stress?$filter={0}"
        ),
        getBmfStressWithFilter: new RoutesTableSectionItem(
            "posrisk/stress/future?$filter={0}"
        ),
        getGarantyModel: new RoutesTableSectionItem(
            "posrisk/riskmodel/updateinvalid/{0}"
        ),
        setAccountPermission: new RoutesTableSectionItem(
            "posrisk/accountpermission"
        ),
    });

    /**
     * Compõe um uri que exige parâmetros
     * @param uri Request URI
     * @param args Demais argumentos do request em ordem => {0} primeiro argumento, {1} segundo argumento, {...x} x argumento
     */
    public static composeUri(
        uri: RoutesTableSectionItem,
        ...args: any[]
    ): string {
        let uriResult = uri.uri;
        for (let i = 0; i < args.length; i++) {
            uriResult = uriResult.replace(`{${i}}`, args[i]);
        }
        return uriResult;
    }
}
